import {Component, inject, OnInit} from '@angular/core';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';
import {Button} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {DialogHelper} from '../../../modules/shared/helper/dialog-helper';
import {ViewService} from '../../../modules/shared/service/view.service';
import {CheckboxComponent} from '../../abstract/checkbox/checkbox.component';

@Component({
    selector: 'app-image-chooser',
    templateUrl: './image-chooser.component.html',
    styleUrls: ['./image-chooser.component.scss'],
    standalone: true,
  imports: [ImageCropperModule, MessageModule, FormsModule, InputText, Button, TranslatePipe, CheckboxComponent]
})
export class ImageChooserComponent implements OnInit
{
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  public view = inject(ViewService);

  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageSelected = false;

  uploading = false;
  errorMsg = '';

  maxWidth = 256;
  policyAccepted = false;

  public static showDialog(dialogService: DialogService, data: any, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      ImageChooserComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant(data?.header ? data?.header : 'CHOOSE_FILE_IMAGE'),
        width: DialogHelper.getDialogWidth(800),
        data
      }));
  }

  ngOnInit(): void
  {
    if (this.config.data.data?.maxWidth > 0)
      this.maxWidth = this.config.data.data.maxWidth;
  }

  fileChangeEvent(event: any): void
  {
    if (event?.target?.files?.length > 0)
    {
      const file = event.target.files[0];
      if (!file?.type.startsWith('image/'))
      {
        alert('Nur Bilder erlaubt / Only images allowed');
        return;
      }
    }

    this.imageSelected = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent): void
  {
    this.croppedImage = event.base64;
  }

  imageLoaded(): void
  {
    // show cropper
  }

  cropperReady(): void
  {
    // cropper ready
  }

  loadImageFailed(): void
  {
    // show message
  }

  saveImage(): void
  {
    if (!this.policyAccepted)
      return;
    // this.uploading = true;

    const imageFormData = new FormData();
    // console.log('Dateigröße geändert, resolve: ', resolveBlob);
    imageFormData.append('image', this.dataURLtoFile(this.croppedImage, 'profile.jpg'));
    // console.log('imageFormData.append name: ', file.name);

    this.ref.close({
      success: true,
      image: this.croppedImage,
      imageFormData
    });

    /*this.backendService.uploadImage(this.croppedImage, this.accountId).subscribe(
      data =>
      {
        console.log('Bild hochgeladen', data);

        this.uploading = false;
        this.ref.close(true);
      },
      error =>
      {
        console.log('error', error);

        this.uploading = false;
        this.errorMsg = new RestErrorHelper().getErrorStr(error)
      }
    );*/
  }

  private dataURLtoFile(dataUrl, filename): File
  {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--)
      u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }
}
